exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-tag i{margin-right:4px}.el-tag.el-tag--success{background-color:rgba(103,194,58,.1);border-color:rgba(103,194,58,.2);color:#67c23a}.el-tag.el-tag--primary{background-color:rgba(64,158,255,.1);border-color:rgba(64,158,255,.2);color:#409eff}.el-tag.el-tag--warning{background-color:rgba(230,162,60,.1);border-color:rgba(230,162,60,.2);color:#e6a23c}.el-tag.el-tag--danger{background-color:rgba(245,108,108,.1);border-color:rgba(245,108,108,.2);color:#f56c6c}.el-tag.el-tag--info{background-color:rgba(144,147,153,.1);border-color:rgba(144,147,153,.2);color:#909399}", ""]);

// exports
